import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BlurbComponent } from '@shared/components/blurb/blurb.component';

@Component({
 selector: 'formly-blurb',
 template: `
   <app-blurb [message]="props.label"></app-blurb>
 `,
 imports: [BlurbComponent]
})
export class FormlyBlurbComponent extends FieldType {
}
